import { styled, Box, css } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import type { TabsVariant } from '../../Tabs.styles';

const underlineVariant = css`
  height: 48px;
  padding: 0 16px;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.mono8};
  flex: 0 0 auto;
`;

const pillVariant = css`
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.mono10};
  min-width: ${({ isMobile }: { isMobile?: boolean }) => (isMobile ? '152px' : 'initial')};
  flex: 1;
`;

export const ToggleWrapper = styled(Box)<{ isMobile?: boolean; variant?: TabsVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${animationTransition('color')};
  text-decoration: none;
  cursor: pointer;

  ${({ variant }) => (variant === 'underline' ? underlineVariant : pillVariant)}

  &.active {
    color: ${({ theme }) => theme.colors.mono14};
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
